import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import Tolkienfix from './Tolkienfix';
import * as serviceWorker from './serviceWorker';

import 'semantic-ui-css/semantic.min.css';
import './index.css';

// ReactDOM.render(<App />, document.getElementById('root'));
ReactDOM.render(<Tolkienfix />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
